import { TERMS_VERSION } from './legalLinks';

/**
 * A ticked consent checkbox is a pre-authentication fact, but the record of it is
 * written post-authentication (the provider buttons navigate away and the page is
 * rebuilt). This marker carries the accepted version across that gap. It lives in
 * localStorage, which survives the OAuth round trip back to the same tenant origin.
 */
const PENDING_CONSENT_KEY = 'r41_pending_terms_consent';

export function markTermsConsentPending(): void {
  try {
    localStorage.setItem(PENDING_CONSENT_KEY, TERMS_VERSION);
  } catch {
    // Without the marker the record is simply not written; login is unaffected.
  }
}

export function getPendingTermsConsent(): string | null {
  try {
    return localStorage.getItem(PENDING_CONSENT_KEY);
  } catch {
    return null;
  }
}

export function clearPendingTermsConsent(): void {
  try {
    localStorage.removeItem(PENDING_CONSENT_KEY);
  } catch {
    // ignored
  }
}
